import { $el, createElem, getStrTypeAttr, removeAttrs, setCss, setHtml } from '../../dom-utils';
import PREFIX from '../prefix';
var Breadcrumb = /** @class */ (function () {
    function Breadcrumb() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-breadcrumb', { all: true });
        this._create(this.COMPONENTS);
    }
    Breadcrumb.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var separator = _this._attrs(node).separator;
            _this._createItem(node, separator);
            removeAttrs(node, ['separator']);
        });
    };
    Breadcrumb.prototype._createItem = function (node, separator) {
        var children = node.children;
        var Fragment = document.createDocumentFragment();
        Array.from(children).forEach(function (child) {
            var Wrapper = createElem('span');
            var Separator = createElem('span');
            Separator.className = PREFIX.breadcrumb + "-item-separator";
            // 设置分隔符
            setHtml(Separator, "" + separator);
            child.classList.add(PREFIX.breadcrumb + "-item-link");
            // 初始化为行内块样式
            setCss(child, 'display', 'inline-block');
            Wrapper.append(child, Separator);
            Fragment.appendChild(Wrapper);
        });
        node.appendChild(Fragment);
    };
    Breadcrumb.prototype._attrs = function (node) {
        return {
            separator: getStrTypeAttr(node, 'separator', '/')
        };
    };
    return Breadcrumb;
}());
export default Breadcrumb;
